import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React, { Fragment } from 'react';
import CustomLink from '../CustomLink';

const useStyles = makeStyles(theme => ({
    nested: {
        paddingLeft: theme.spacing(4),
    },

    root: {
        backgroundColor: theme.palette.background.paper,
        maxWidth: 360,
        width: '100%',
        '& .MuiIcon-root': {
            color: '#666',
        },
        '& .Mui-selected .MuiIcon-root, .MuiListItem-root:hover .MuiIcon-root': {
            color: theme.palette.secondary.main,
        },
    },
}));

function NestedList({ active_event_id, activeModules, location, match, sidebar }: any) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    function handleClick() {
        setOpen(!open);
    }
    let eventsPath, dashboardPath;
        eventsPath = '/events';
        dashboardPath = `/events/${match.params.id}`;

    const { primary, secondary } = activeModules;
    return (
        <List aria-labelledby="nested-list-subheader" className={classes.root} component="nav">
            <CustomLink label="All Events" route={eventsPath} tooltip="All Events">
                <Icon>event</Icon>
            </CustomLink>
            <Divider />
            <CustomLink
                label="Dashboard"
                route={dashboardPath}
                selected={location.pathname === dashboardPath}
                tooltip="Event Dashboard"
            >
                <Icon>dashboard</Icon>
            </CustomLink>
            {primary && primary.schedule && (
                <CustomLink
                    label="Itinerary"
                    route={`${match.url}/itinerary`}
                    selected={location.pathname.includes('itinerary')}
                    tooltip="Itinerary"
                >
                    <Icon>schedule</Icon>
                </CustomLink>
            )}

            {primary && primary.discover && (
                <CustomLink
                    label="Discover"
                    route={`${match.url}/discover`}
                    selected={location.pathname.includes('discover')}
                    tooltip="Discover"
                >
                    <Icon>sort</Icon>
                </CustomLink>
            )}
            {primary && primary.feed && (
                <CustomLink
                    label="Moments"
                    route={`${match.url}/moments`}
                    selected={location.pathname.includes('moments')}
                    tooltip="Moments"
                >
                    <Icon>photo_camera</Icon>
                </CustomLink>
            )}

            {primary && primary.inbox && (
                <Fragment>
                    <ListItem
                        button
                        onClick={handleClick}
                        selected={location.pathname.includes('channels') || location.pathname.includes('notifications')}
                    >
                        <ListItemIcon>
                            <Icon>message</Icon>
                        </ListItemIcon>
                        <ListItemText primary="Inbox" /> {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {secondary && secondary.isChannelsEnabled && (
                                <CustomLink
                                    label="Channels"
                                    nested
                                    route={`${match.url}/channels`}
                                    selected={location.pathname.includes('channels')}
                                    tooltip="Channels"
                                >
                                    <Icon>forum</Icon>
                                </CustomLink>
                            )}
                            <CustomLink
                                label="Messages"
                                nested
                                route={`${match.url}/notifications`}
                                selected={location.pathname.includes('notifications')}
                                tooltip="Messages"
                            >
                                <Icon>sms</Icon>
                            </CustomLink>
                        </List>
                    </Collapse>
                </Fragment>
            )}
            <CustomLink
                label="Profile"
                route={`${match.url}/profile`}
                selected={location.pathname.includes('profile')}
                tooltip="Profile"
            >
                <Icon>person</Icon>
            </CustomLink>
        </List>
    );
}

export default withRouter(NestedList);
